import L from 'leaflet';
import "leaflet/dist/leaflet.css";

import pinBike from "../assets/icons/bike.png";
import pinDestination from "../assets/icons/flag.svg";

import pinApotek from "../assets/icons/apotek.svg";
import pinKantor from "../assets/icons/kantor.svg";
import pinSpbu from "../assets/icons/spbu.svg";
import pinTempatIbadah from "../assets/icons/tempat_ibadah.svg";
import pinTempatMakan from "../assets/icons/tempat_makan.svg";
import pinToko from "../assets/icons/toko.svg";

import markerIcon from 'leaflet/dist/images/marker-icon.png';

/* =========================
   ICON POI (20x20 - CENTER)
========================= */
const center20 = {
    iconSize: [20, 20] as [number, number],
    iconAnchor: [10, 10] as [number, number],
    popupAnchor: [0, -10] as [number, number],
  };
  
  

export const MyIconApotek = L.icon({
  iconUrl: pinApotek,
  ...center20,
});

export const MyIconKantor = L.icon({
  iconUrl: pinKantor,
  ...center20,
});

export const MyIconSpbu = L.icon({
  iconUrl: pinSpbu,
  ...center20,
});

export const MyIconTempatIbadah = L.icon({
  iconUrl: pinTempatIbadah,
  ...center20,
});

export const MyIconTempatMakan = L.icon({
  iconUrl: pinTempatMakan,
  ...center20,
});

export const MyIconToko = L.icon({
  iconUrl: pinToko,
  ...center20,
});

/* =========================
   DESTINATION (FLAG / PIN)
========================= */
export const MyIconDestination = L.icon({
  iconUrl: pinDestination,
  iconSize: [33, 100],
  iconAnchor: [12, 40],
  popupAnchor: [0, -40],
});

/* =========================
   LEAFLET DEFAULT MARKER
========================= */
export const MyIconPickup = L.icon({
  iconUrl: markerIcon,
  iconSize: [25, 40],
  iconAnchor: [12, 40],
  popupAnchor: [0, -40],
});

export const MyIconCurrent = L.icon({
  iconUrl: markerIcon,
  iconSize: [25, 40],
  iconAnchor: [12, 40],
  popupAnchor: [0, -40],
});

/* =========================
   BIKER / DRIVER
========================= */
export const MyIconBiker = L.icon({
  iconUrl: pinBike,
  iconSize: [30, 30],
  iconAnchor: [15, 15],
  popupAnchor: [0, -15],
});



// Function helper untuk ambil icon berdasarkan type
export const getIconByType = (type:any) => {
    switch (type) {
        case "apotek":
            return MyIconApotek;
        case "kantor":
            return MyIconKantor;
        case "spbu":
            return MyIconSpbu;
        case "tempat_ibadah":
            return MyIconTempatIbadah;
        case "tempat_makan":
            return MyIconTempatMakan;
        case "toko":
            return MyIconToko;
        case "search":
            return MyIconCurrent;
        case "destination":
            return MyIconDestination;
        default:
            return MyIconToko;
    }
};